import { setWardsCurrentPageNo } from "pages/AllWards/allWardsSlice";
import { useCallback, useEffect, useState } from "react";
import { TableDatePicker } from "themes/Icon";

import { useDispatch } from "react-redux";
// import { DeleteIcon, EditIcon, TableDatePicker } from "themes/Icon";
import AvatarComp from "themes/elements/Avatar";
import ButtonComp from "themes/elements/Button";
import EmptyState from "themes/elements/EmptyState";
import PaginationComp from "themes/elements/Pagination";
// import { isPermit } from "utils/permissionCheck";
import DateRangePickerComp from "themes/elements/DateRangePickerComp";
import SearchComp from "themes/elements/Search";
import SelectComp from "themes/elements/Select";
import TooltipComp from "themes/elements/Tooltip";
import "../table_comp.scss";

function AllWardsTable({
  column,
  data,
  dataClick,
  approve = false,
  // onDeleteAction,
  currentPageNo,
  totalPageNo,
  // handleEdit,
  setSelectedData = () => {},
  isLoading,
  // editAction,
  filterRegion,
  filterWard,
  filterCouncillor,
  filterTerm,
  filterReason,
  filterReqCouncillor,
  filterStatus,

  setFilterStatus = () => {},
  setFilterTerm = () => {},
  setFilterRegion = () => {},
  setFilterWard = () => {},
  setFilterCouncillor = () => {},
  setIsDetails = () => {},
}) {
  const [currentPageData, setCurrentPageData] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    setCurrentPageData(data);
    setSelectedData([]);
  }, [data]);

  const handlePageChange = (page) => {
    dispatch(setWardsCurrentPageNo(page));
  };

  function debounce(func, delay) {
    let timerId;
    return function (...args) {
      if (timerId) {
        clearTimeout(timerId);
      }
      timerId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  }

  const handleStatusChange = (value, item) => {
    dispatch(setWardsCurrentPageNo(1));

    setFilterStatus(item);
  };

  const handleSearchChangeDebounced = useCallback(
    debounce((value, type) => {
      dispatch(setWardsCurrentPageNo(1));
      if (type === "region") {
        setFilterRegion(value);
      } else if (type === "ward") {
        setFilterWard(value);
      } else if (type === "councilor") {
        setFilterCouncillor(value);
      }
    }, 50),
    []
  ); // 300 ms debounce time

  // This function is what gets called by the event listener
  const handleSearchChange = (event, type) => {
    const value = event.target.value;
    handleSearchChangeDebounced(value, type);
  };

  const SkeletonRow = ({ columns }) => (
    <tr className="table-row">
      {columns.map((col, index) => (
        <td key={index} className="table-data" style={{ width: col.width }}>
          <div className="skeleton-box"></div>
        </td>
      ))}
    </tr>
  );

  const handleCreatedDateChange = (dateString) => {
    dispatch(setWardsCurrentPageNo(1));
    if (dateString) {
      setFilterTerm(dateString);
    } else {
      setFilterTerm(null);
    }
  };

  const clearFilters = () => {
    dispatch(setWardsCurrentPageNo(1));
    setCurrentPageData(data);
    setFilterRegion("");
    setFilterWard("");
    setFilterTerm();
    setFilterCouncillor("");
  };

  const onDataClick = (row) => {
    dataClick(row);
  };

  return (
    <div className="table-wrapper">
      <table className="table-comp">
        <thead className="table-head">
          <tr className="table-row">
            {column.map((col, i) => (
              <th
                className="table-header"
                key={i}
                style={{ minWidth: col.width }}
              >
                <span className="flex align-center gap-3">{col.title}</span>
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="table-body">
          <tr className="table-row">
            {column.map((col, i) => (
              <td className="table-data" style={{ width: col.width }} key={i}>
                {col.filter === "searchTitle" ? (
                  <SearchComp
                    className="table-search"
                    height={33}
                    bgNone
                    placeholder="Search..."
                    value={filterRegion}
                    onChange={(e) => handleSearchChange(e, "region")}
                  />
                ) : col.filter === "searchCouncillor" ? (
                  <SearchComp
                    className="table-search"
                    height={33}
                    bgNone
                    placeholder="Search..."
                    value={filterCouncillor}
                    onChange={(e) => handleSearchChange(e, "councilor")}
                  />
                ) : col.filter === "searchNumber" ? (
                  <SearchComp
                    type="number"
                    className="table-search"
                    height={33}
                    bgNone
                    placeholder="Search..."
                    value={filterWard}
                    onChange={(e) => handleSearchChange(e, "ward")}
                  />
                ) : col.filter === "searchReason" ? (
                  <SearchComp
                    className="table-search"
                    height={33}
                    bgNone
                    placeholder="Search..."
                    value={filterReason}
                    onChange={(e) => handleSearchChange(e, "reason")}
                  />
                ) : col.filter === "selectStatus" ? (
                  <SelectComp
                    allowClear={false}
                    value={filterStatus}
                    className="table-select"
                    placeholder={col.placeholder ? col.placeholder : col.title}
                    onChange={handleStatusChange}
                    data={col.dropDown.map((item) => ({
                      label: item.name,
                      value: item.value,
                    }))}
                    onClear={false}
                  />
                ) : col.filter === "searchRequsted" ? (
                  <SearchComp
                    type="text"
                    className="table-search"
                    height={33}
                    bgNone
                    placeholder="Search..."
                    value={filterReqCouncillor}
                    onChange={(e) => handleSearchChange(e, "requester")}
                  />
                ) : col.filter === "datePicker" ? (
                  <DateRangePickerComp
                    className="table-date-picker"
                    suffixIcon={<TableDatePicker />}
                    onChange={handleCreatedDateChange}
                    value={filterTerm}
                  />
                ) : null}
              </td>
            ))}
          </tr>
          {(filterRegion || filterWard || filterCouncillor || filterTerm) && (
            <div className="clr-btn-container">
              <ButtonComp height={16} variant="link" onClick={clearFilters}>
                Clear filters
              </ButtonComp>
            </div>
          )}
          {!isLoading ? (
            currentPageData?.length > 0 ? (
              currentPageData.map((row) => (
                <tr className="table-row" key={row?.id}>
                  {column.map((col, colIndex) => {
                    return (
                      <td
                        style={{ width: col.width }}
                        className="table-data"
                        key={colIndex}
                      >
                        {col.key === "councillor" && row[col.key] !== null ? (
                          <div className="flex align-center no_cursor">
                            {row?.councilor_image?.length > 0 &&
                            row[col.key] !== null ? (
                              <AvatarComp
                                shape="square"
                                size={32}
                                blue
                                src={row.councilor_image}
                              />
                            ) : (
                              <AvatarComp size={32} shape="square" blue>
                                {row[col.key]?.replace(" ", "")[0]}
                              </AvatarComp>
                            )}
                            <span
                              className="table-title ml-3  no_cursor"
                              onClick={() => {
                                setIsDetails(true);
                              }}
                            >
                              {row[col.key]}
                            </span>
                          </div>
                        ) : col.key === "created_user_name" &&
                          row[col.key] !== null ? (
                          <div
                            className={`flex align-center  ${
                              approve ? "approve" : ""
                            }`}
                          ></div>
                        ) : colIndex === 0 ? (
                          // <TooltipComp title={row[col.key]}>
                          <span
                            className="table-title ml-3"
                            onClick={() => {
                              onDataClick(row);
                              setIsDetails(true);
                            }}
                          >
                            {row[col.key]}
                          </span>
                        ) : colIndex === 1 ? (
                          // <TooltipComp title={row[col.key]}>
                          <span
                            className="table-title ml-3"
                            onClick={() => {
                              onDataClick(row);
                              setIsDetails(true);
                            }}
                          >
                            {row[col.key]}
                          </span>
                        ) : (
                          <TooltipComp title={row[col.key]}>
                            <span className=" align-center gap-2 limit-lines">
                              {row[col.key]}
                            </span>
                          </TooltipComp>
                        )}
                      </td>
                    );
                  })}
                </tr>
              ))
            ) : (
              <EmptyState />
            )
          ) : (
            Array(10)
              .fill(0)
              .map((_, index) => <SkeletonRow key={index} columns={column} />)
          )}
        </tbody>
      </table>

      <PaginationComp
        isLoading={isLoading}
        currentPageNo={currentPageNo}
        total={totalPageNo}
        onChange={handlePageChange}
      />
    </div>
  );
}

export default AllWardsTable;
